import React, { useState } from 'react'
import emailsjs from 'emailjs-com';
import { useRef } from "react";


const Contact = () => {
    const form = useRef();
    const [sendStatus, setSendStatus] = useState('');

    const sendEmail = (e) => {
        e.preventDefault();
        setSendStatus('sending');
        
        emailsjs.sendForm('service_lhc9qvj', 'template_f29srhg', form.current, 'p3ovuG5gt4Bwk35Cs' )
            .then((result)=>{
                console.log(result.text);
                setSendStatus('success');
                form.current.reset();
                setTimeout(() => setSendStatus(''), 4000);
            }, (error) =>{
                console.log(error.text);
                setSendStatus('error');
                setTimeout(() => setSendStatus(''), 4000);
            });
        
    };
    return (
        <section id='contact' className='pb-16'>
            <div className='container'>
                <h2 className='text-headingColor font-[700] text-[2.5rem] mb-8'>Get in touch</h2>
                <div className='md:flex justify-between items-center'>
                    <div className='w-full md:w-1/2 h-[300px] sm:h-[450px]'>
                        <iframe title='google-maps' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.7!2d106.7676607!3d-6.2746148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1b3433ad249%3A0x94bb905cd471bde8!2sRT.5%2FRW.5%2C+Pondok+Pinang%2C+Kebayoran+Lama%2C+South+Jakarta+City%2C+Jakarta!5e0!3m2!1sid!2sid!4v1694586801903!5m2!1sid!2sid"
                            className='border-0 w-full h-full rounded-[8px]' allowFullScreen="" loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"></iframe>
                        
                        {/* Contact Info */}
                        <div className='mt-5 space-y-3'>
                            <div className='flex items-center gap-3'>
                                <span className='text-primaryColor text-[20px]'><i className="ri-map-pin-2-fill"></i></span>
                                <p className='text-smallTextColor font-[500] text-[15px]'>
                                    <a href='https://maps.app.goo.gl/Mfkd5778vAAHtsWp7' target='_blank' rel='noreferrer'
                                        className='hover:text-primaryColor ease-in duration-200'>
                                        Pondok Pinang, Kebayoran Lama, Jakarta Selatan, DKI Jakarta
                                    </a>
                                </p>
                            </div>
                            <div className='flex items-center gap-3'>
                                <span className='text-primaryColor text-[20px]'><i className="ri-mail-fill"></i></span>
                                <p className='text-smallTextColor font-[500] text-[15px]'>
                                    <a href='mailto:afitdesantos@gmail.com' className='hover:text-primaryColor ease-in duration-200'>
                                        afitdesantos@gmail.com
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='w-full mt-8 md:mt-0 md:w-1/2 sm:h-[450px] lg:flex items-center bg-indigo-100 px-4 lg:px-8 py-8'>
                        <form className='w-full' ref={form} onSubmit={sendEmail}>
                            {/* Hidden field to send to your email */}
                            <input type='hidden' name='to_email' value='afitdesantos@gmail.com' />
                            
                            <div className='mb-5'>
                                <input type='text' name='user_name' placeholder='Enter your name' required
                                    className='w-full p-3 focus:outline-none rounded-[5px]'></input>
                            </div>
                            <div className='mb-5'>
                                <input type='email' name='user_email' placeholder='Enter your email' required
                                    className='w-full p-3 focus:outline-none rounded-[5px]'></input>
                            </div>
                            <div className='mb-5'>
                                <textarea type='text' name='message' rows={3} placeholder='Write Your Message' required
                                    className='w-full p-3 focus:outline-none rounded-[5px]'></textarea>
                            </div>

                            <button type='submit' 
                                disabled={sendStatus === 'sending'}
                                className='w-full p-3 focus:outline-none rounded-[5px] bg-smallTextColor text-white hover:bg-headingColor text-center ease-linear duration-150 disabled:opacity-60'>
                                {sendStatus === 'sending' ? 'Sending...' : 'Send Message'}
                            </button>

                            {sendStatus === 'success' && (
                                <p className='mt-3 text-green-600 font-[500] text-center'>
                                    ✅ Message sent successfully! We'll get back to you soon.
                                </p>
                            )}
                            {sendStatus === 'error' && (
                                <p className='mt-3 text-red-500 font-[500] text-center'>
                                    ❌ Failed to send message. Please try again.
                                </p>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact